<template>
    <div class="main-product">
        <div class="head">
            <div class="container">
                <el-row :gutter="60">
                    <el-col :span="16" :xs="24" class="prodect-des" >
                      <div class="type-title">{{$t("mainBusiness.gpc.header.typeTitle")}}</div>
                      <h2>{{$t("mainBusiness.gpc.header.title")}}<span>{{$t("mainBusiness.gpc.header.enTitle")}}</span></h2>
                      <p>{{$t("mainBusiness.gpc.header.des")}}</p>
                    </el-col>
                    <el-col :span="8" :xs="24">
                        <div class="pic">
                            <img src="../../assets/img/home/gpc.png" />
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="container">
            
            <el-tabs v-model="activeName"  @tab-click="handleClick">
                <el-tab-pane :label="$t('mainBusiness.gpc.parameters.tabs.internal')" name="first">
                    <div class="parameters">
                        <h2>{{$t('mainBusiness.gpc.parameters.title')}}</h2>
                        <div v-for="(item,index) in $t('mainBusiness.gpc.parameters.parameterRow')" :key="index" class="box-row">
                            <el-row :gutter="30">
                                <el-col :span="6"  >
                                    <div class="pic">
                                        <img :src="item.pic" />
                                    </div>
                                </el-col>
                                <el-col :span="18" >
                                    <el-row :gutter="30">
                                        <el-col :span="8" :xs="24" v-for="list in item.lists" :key="list.name">
                                            <div class="parameters-value">
                                            <h3 class="title">{{list.value}}</h3>
                                            <p>{{list.name}}</p> 
                                            </div>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <div class="petroleum-bases">
                        <div class="headline2">
                            <span>{{$t("mainBusiness.gpc.petroleumBases.headline2.title")}}</span><span>_</span><span>{{$t("mainBusiness.gpc.petroleumBases.headline2.enTitle")}}</span>
                        </div>
                        <el-row :gutter="30">
                            <el-col :span="12" :xs="24" v-for="(item,index) in $t('mainBusiness.gpc.petroleumBases.lists')" :key="index" class="box-row">
                                <el-row :gutter="30">
                                    <el-col :span="6" >
                                        <div class="pic">
                                            <img :src="item.pic" />
                                        </div>
                                    </el-col>
                                    <el-col :span="18" class="petroleum-bases-des" >   
                                        <h2>{{item.title}}</h2>
                                        <p>{{item.des}}</p>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </div>
                    
                </el-tab-pane>
                <el-tab-pane :label="$t('mainBusiness.gpc.parameters.tabs.foreign')" name="second">
                    <div class="parameters">
                        <h2>{{$t('mainBusiness.gpc.parameters.title')}}</h2>
                        <div v-for="(item,index) in $t('mainBusiness.gpc.parameters.foreignParameterRow')" :key="index" class="box-row">
                            <el-row :gutter="30">
                                <el-col :span="6"  >
                                    <div class="pic">
                                        <p>{{item.title}}</p>
                                        <img :src="item.pic" />
                                    </div>
                                </el-col>
                                <el-col :span="18" >
                                    <el-row :gutter="30">
                                        <el-col :span="8" :xs="24" v-for="list in item.lists" :key="list.name">
                                            <div class="parameters-value">
                                            <h3 class="title">{{list.value}}</h3>
                                            <p>{{list.name}}</p> 
                                            </div>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div class="storage-base">

                <div class="headline2">
                    <span>{{$t("mainBusiness.gpc.storageBase.headline2.title")}}</span><span>_</span><span>{{$t("mainBusiness.gpc.storageBase.headline2.enTitle")}}</span>
                </div>
                <p class="des">
                    {{$t("mainBusiness.gpc.storageBase.des")}}
                </p>
                        
                <el-row :gutter="30">
                    <el-col :span="6" :xs="24">
                        <div class="pic">
                            <img src="../../assets/img/mainBusiness/jd1.jpg" />
                        </div>
                    </el-col>
                    <el-col :span="6" :xs="24" >
                        <div class="pic">
                            <img src="../../assets/img/mainBusiness/jd2.jpg" />
                        </div>
                    </el-col>
                    <el-col :span="6"  :xs="24">
                        <div class="pic">
                            <img src="../../assets/img/mainBusiness/jd3.jpg" />
                        </div>
                    </el-col>
                    <el-col :span="6"  :xs="24">
                        <div class="pic">
                            <img src="../../assets/img/mainBusiness/jd4.jpg" />
                        </div>
                    </el-col>
                </el-row> 
            </div>
            
            <div class="recommend">
                <div class="headline2">
                    <span>{{$t("mainBusiness.gpc.recommend.headline2.title")}}</span><span>_</span><span>{{$t("mainBusiness.gpc.recommend.headline2.enTitle")}}</span>
                </div>
                <el-row :gutter="30">
                    <el-col :span="6" :xs="12" v-for="(item,index) in tabLists" :key="index" @click.native="toDetail(item.itemNo)">
                        <div class="pic" ref="pic" :style="{height:imgH+'px'}">
                            <img :src="item.mainPicUrl" />
                        </div>
                        <div class="des-row">
                            <p>{{item.itemName}}</p>
                            <p>{{item.introduction}}</p>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getItemlist } from "@/api/product"
export default {
    name:"Gpc",
    data(){
        return {
            activeName: 'first',
            imgH:0,
            tabLists:[]
        }
    },
    computed:{
        ...mapGetters(['language'])
    },
    mounted(){
        this.getList();
    },
    methods:{
        handleClick(tab, event) {
            console.log(tab, event);
        },
        // 获取列表
        getList(){
            const data={
                aboutType:'1',
                page:1,
                size:1000
            }
            getItemlist( this.language,data ).then(res=>{
                const { content } = res;
                this.tabLists = content;
                this.$nextTick(()=>{
                this.imgH=this.$refs.pic[0].offsetWidth;
                })
            })
        },
        toDetail(itemNo){
            this.$router.push({path:`/besinessScope/bulkTrade/detail/${itemNo}`});
        },
    }
}
</script>
<style lang="scss" scoped>
.main-product{
    ::v-deep .el-tabs__active-bar{
        width:36px ;
    }
    ::v-deep .el-tabs__item{
        font-size: 18px ;
    }
    .head{      
        padding:150px 0 100px;
        text-align: justify;
        background: linear-gradient(to bottom, #e8eff8 0%, #fff 100%);
        .prodect-des {
            .type-title{
                border-bottom:2px solid #0054A7;
                display: inline-block;
                font-size: 20px;
                line-height: 2;
                margin-bottom:30px;
            }
            h2 {
                color: #000;
                font-size: 40px;
                font-weight: 800;
                margin-bottom: 30px;
                span {
                    color: #888;
                    font-size: 20px;
                    margin-left: 20px;
                }
            }
        }
        .pic{
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                max-width: 90%;
                margin-top:20px;
            }
        }
    }
    .parameters{
        width:80%;
        margin:0 auto;
        h2{
            margin:60px 0;
            font-weight: bold;
            font-size: 40px;
        }
        .box-row{
            margin-bottom:80px;
            .pic{
                text-align: center;
                p{
                    color:#0054A7;
                    text-align: left;
                    font-size: 30px;
                    font-weight: bold;
                }
                img{
                    max-width: 80%;
                    max-height: 80%;
                }
            }
            .parameters-value{
                padding-bottom:10px;
                margin-bottom:10px;
                border-bottom:1px solid #ccc;
                .title{
                    font-size: 40px;
                    color:#000;
                }
                &:hover{
                    border-bottom:1px solid #0054A7;
                    color:#0054A7;
                    .title{
                        color:#0054A7;
                    }
                }

            }
        }
        
    }
    .petroleum-bases{
        .box-row{
            margin-bottom: 30px;
            .petroleum-bases-des {
                h2 {
                    font-weight: 800;
                    margin-bottom: 20px;
                }
                p{
                color:#B7B7B7;
                }
            }
            .pic{
                height:240px;
                text-align: center;
                img{
                    max-width: 90%;
                }
            }
        }   
    }
    .storage-base{
        .des{
            width:900px;
            margin: 0 auto 40px;
            text-align: justify;
        }
        .pic{
            img{
                width: 100%;
                height:260px;
                object-fit: cover;
                border-radius: 10px;
            }
        }
    }
    .recommend{
        .pic{
            //background: #F4F4F4;
            border-radius: 22px;
            // display: flex;
            // justify-content: center;
            // align-items: center;
            overflow: hidden;
            cursor: pointer;
            img{
              width:100%;
              height:100%;
              object-fit: cover;
            }
        }
        .des-row{
            padding:15px;
            p{
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }
    @media screen and (max-width:768px){
        .head{      
            padding:30px 0 20px;
            .prodect-des {
                h2 {
                    font-size: 22px;
                }
            }
            .pic{
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    max-width: 90%;
                    margin-top:20px;
                }
            }
        }
        .parameters{
            width:100%;
            h2{
                margin:30px 0;
                font-size: 24px;
            }
            .box-row{
                margin-bottom:40px;
                .pic{
                    text-align: center;
                    p{
                        color:#0054A7;
                        text-align: left;
                        font-size: 18px;
                        font-weight: bold;
                    }
                    img{
                        max-width: 100%;
                        max-height: 100%;
                    }
                }
                .parameters-value{
                    .title{
                        font-size: 24px;
                    }
                }
            }
            
        }
        .petroleum-bases{
            .box-row{
                .pic{
                    height:auto;
                    text-align: center;
                    img{
                        max-width: 100%;
                    }
                }
            }   
        }
        .storage-base{
            padding-bottom:40px;
            .des{
                width:100%;
                margin: 0 auto 20px;
            }
            img{
                margin-bottom:30px;
            }
        }
    }
}
</style>